import { TextCell } from '@common/components/TextCell';

interface VinCellProps {
	vin?: string;
}

export const VinCell = ({ vin }: VinCellProps) => {
	return <TextCell value={vin} />;
};
